import React from 'react';
import { ChevronRight } from 'lucide-react';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import NextStepButton from '../../../../../Components/NextStepButton';

interface NextButtonComponentProps {
    processingState: ProcessingState;
}

function NextButtonComponent({ processingState }: NextButtonComponentProps): React.JSX.Element {
    return (
        <NextStepButton
            loading={processingState === ProcessingState.Processing}
            endIcon={<ChevronRight className="size-5" aria-hidden />}
        >
            {UIStrings.Next}
        </NextStepButton>
    );
}

export default NextButtonComponent;
